const travellingPastMockData = {
  summaryLoaded: true,
  summaryError: false,
  summaryData: {
    "eventsCount": 14115,
    "devicesCount": 4514,
    "poisCount": 2573,
    "poisTotalCount": 6804
  },
  overTimeLoaded: true,
  overTimeError: false,
  overTimeData: [{
      hour: '0',
      count: 2,
      percent: 2,
    },
    {
      hour: '1',
      count: 1,
      percent: 1,
    },
    {
      hour: '2',
      count: 1,
      percent: 1,
    },
    {
      hour: '3',
      count: 1,
      percent: 1,
    },
    {
      hour: '4',
      count: 2,
      percent: 2,
    },
    {
      hour: '5',
      count: 3,
      percent: 3,
    },
    {
      hour: '6',
      count: 4,
      percent: 4,
    },
    {
      hour: '7',
      count: 5,
      percent: 5,
    },
    {
      hour: '8',
      count: 7,
      percent: 7,
    },
    {
      hour: '9',
      count: 6,
      percent: 6,
    },
    {
      hour: '10',
      count: 7,
      percent: 7,
    },
    {
      hour: '11',
      count: 9,
      percent: 9,
    },
    {
      hour: '12',
      count: 10,
      percent: 10,
    },
    {
      hour: '13',
      count: 8,
      percent: 8,
    },
    {
      hour: '14',
      count: 10,
      percent: 10,
    },
    {
      hour: '15',
      count: 6,
      percent: 6,
    },
    {
      hour: '16',
      count: 5,
      percent: 5,
    },
    {
      hour: '17',
      count: 4,
      percent: 4,
    },
    {
      hour: '18',
      count: 3,
      percent: 3,
    },
    {
      hour: '19',
      count: 3,
      percent: 3,
    },
    {
      hour: '20',
      count: 1,
      percent: 1,
    },
    {
      hour: '21',
      count: 1,
      percent: 1,
    },
    {
      hour: '22',
      count: 1,
      percent: 1,
    },
    {
      hour: '23',
      count: 0,
      percent: 0,
    },
  ],
  dailyAveragesLoaded: true,
  dailyAveragesError: false,
  dailyAveragesData: {
    "Mon": 41,
    "Tue": 44,
    "Wed": 59,
    "Thu": 52,
    "Fri": 51,
    "Sat": 56,
    "Sun": 54,
    "percent": {
      "Mon": 14.421368,
      "Tue": 15.232194,
      "Wed": 13.531326,
      "Thu": 16.123332,
      "Fri": 12.856765,
      "Sat": 14.531218,
      "Sun": 13.765565
    }
  },
  poisLoaded: true,
  poisError: false,
  poisData: [{
      "name": "Countdown",
      "count": 21,
      "percent": 42.857142857142854
    },
    {
      "name": "Airport Countdown",
      "count": 5,
      "percent": 10.204081632653061
    },
    {
      "name": "Newmarket Countdown",
      "count": 3,
      "percent": 6.122448979591836
    },
    {
      "name": "Manukau Countdown",
      "count": 3,
      "percent": 6.122448979591836
    },
    {
      "name": "Takanini Countdown",
      "count": 2,
      "percent": 4.081632653061225
    },
    {
      "name": "Glenfield Countdown",
      "count": 2,
      "percent": 4.081632653061225
    },
    {
      "name": "Kelston Countdown",
      "count": 2,
      "percent": 4.081632653061225
    },
    {
      "name": "St Lukes Countdown",
      "count": 2,
      "percent": 4.081632653061225
    },
    {
      "name": "Mangere East Countdown",
      "count": 1,
      "percent": 2.0408163265306123
    },
    {
      "name": "Sunnynook Countdown",
      "count": 1,
      "percent": 2.0408163265306123
    },
    {
      "name": "Botany Downs Countdown",
      "count": 1,
      "percent": 2.0408163265306123
    },
    {
      "name": "Manukau City Mall Countdown",
      "count": 1,
      "percent": 2.0408163265306123
    },
    {
      "name": "Mt Wellington Countdown",
      "count": 1,
      "percent": 2.0408163265306123
    },
    {
      "name": "Mt Roskill Countdown",
      "count": 1,
      "percent": 2.0408163265306123
    },
    {
      "name": "Countdown Metro",
      "count": 1,
      "percent": 2.0408163265306123
    },
    {
      "name": "Meadowbank Countdown",
      "count": 1,
      "percent": 2.0408163265306123
    },
    {
      "name": "Countdown Mt Eden",
      "count": 1,
      "percent": 2.0408163265306123
    },
    {
      "name": "Papakura Countdown",
      "count": 0,
      "percent": 0
    }
  ],
  repeatDevicesLoaded: true,
  repeatDevicesError: false,
  repeatDevicesData: {
    "repeatPercent": 36.738,
    "uniquePercent": 63.262,
    "averageEvents": 1.62558,
    "averageEventsByPOI": 1.4
  },
};

export default travellingPastMockData;
